(function () {
  'use strict';

  function showError(container, errorEl, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    errorEl.classList.remove('hidden');
    container.classList.add('newsletter__consent--error');
  }

  function hideError(container, errorEl) {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
    errorEl.classList.add('hidden');
    container.classList.remove('newsletter__consent--error');
  }

  function init(container) {
    if (container.dataset.consentInit === 'true') return;
    container.dataset.consentInit = 'true';

    var form = container.closest('form');
    if (!form) return;

    var checkbox = container.querySelector('[data-newsletter-consent-checkbox]');
    var errorEl = container.querySelector('[data-newsletter-consent-error]');
    var message = container.dataset.errorMessage || 'Required';

    if (!checkbox) return;

    form.addEventListener(
      'submit',
      function (e) {
        if (!checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError(container, errorEl, message);
          try {
            checkbox.focus({ preventScroll: true });
          } catch (err) {
            checkbox.focus();
          }
          checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      true
    );

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) hideError(container, errorEl);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = scope.querySelectorAll('[data-newsletter-consent]');
    for (var i = 0; i < containers.length; i++) init(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
